import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'
import SmartBannerAd from './smart-banner'
import Cookie from 'js-cookie'
import AppleStore from '../../../images/appstore.png'
import GooglePlay from '../../../images/googleplay.png'
import { getDeviceType, handleCtaClick, handleDismiss } from './utils'
import { myPgaIOSUrl, myPgaAndroidUrl } from '../../../constants'

const MyPgaBannerAd = () => {
  const displayBanner = Cookie.get('appInstalledOrDismissed')
  const [isDisplaying, setIsDisplaying] = useState(
    !(displayBanner === 'nodisplay')
  )

  const iosProps = {
    appStoreUrl: myPgaIOSUrl,
    altText: 'Apple Store',
    image: AppleStore,
    handleCtaClick: handleCtaClick(setIsDisplaying, 'pga-coach'),
    handleDismiss: handleDismiss(setIsDisplaying, 'pga-coach')
  }

  const androidProps = {
    appStoreUrl: myPgaAndroidUrl,
    altText: 'Google Play',
    image: GooglePlay,
    handleCtaClick: handleCtaClick(setIsDisplaying, 'pga-coach'),
    handleDismiss: handleDismiss(setIsDisplaying, 'pga-coach')
  }

  const deviceType = getDeviceType()

  if (deviceType === 'unknown' || !isMobile || !isDisplaying) return null

  const deviceSpecificProps = deviceType === 'android' ? androidProps : iosProps
  return <SmartBannerAd {...deviceSpecificProps} />
}

export default MyPgaBannerAd
